import { apiGet } from '@/store/api';
import { useAttendanceStore } from '@/store/attendanceStore';

export async function getPortcallAttendances(callId: string | number) {
  const data = await apiGet(`/attendances/portcall/${callId}`);
  useAttendanceStore().setPortcallAttendaces(data);
  return data;
}
